import "../../styles/index.css";
import { Box, Typography, Button } from "@mui/material";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import usePageMeta from "../../utils/usePageMeta";

const Rejection = () => {
  usePageMeta(
    "Application Rejected",
    "Your application to the Gospel and Church Health Framework has been reviewed.",
  );
  return (
    <Box className="verification-container">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h2" className="verification-title1">
          Access Not Authorized.
        </Typography>
        <Typography variant="h6" className="verification-title">
          Your submission has been reviewed.
        </Typography>
        <Typography variant="body1" className="verification-subtitle">
          Thank you for your interest in the The Gospel and Church Health
          Framework. After a careful review of your preliminary information, we
          are unable to grant access to the Framework at this time.
        </Typography>
        <Typography variant="subtitle1" className="verification-subtitle1">
          *This decision is based on our current eligibility requirements for
          this specific diagnostic tool.
        </Typography>
      </Box>
      <Box>
        <Button
          variant="outlined"
          onClick={() =>
            window.open(
              "mailto:churchhealth@citytocityasiapacific.com",
              "_blank",
            )
          }
          sx={{
            borderRadius: "10px", // pill shape
            borderWidth: "1px",
            borderColor: "#8A8F94", // light grey border
            textTransform: "none", // keep text case
            height: 40,
            fontSize: 12,
            letterSpacing: 0.8,
            padding: "6px 16px",
            color: "#2A3238",
            lineHeight: 1.5,
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            "&:hover": {
              borderWidth: "1px",
              borderColor: "#2A3238",
              backgroundColor: "transparent",
            },
          }}
        >
          CONTACT CTCAP
          <HeadsetMicOutlinedIcon sx={{ fontSize: 16 }} />
        </Button>
        <Typography variant="subtitle1" className="verification-subtitle1">
          Contact for Clarification or if you would like to provide additional
          context regarding your ministry, please contact our administrative
          team.
        </Typography>
      </Box>
    </Box>
  );
};

export default Rejection;
